import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { SolutionsList } from './modules/SolutionListOneApp';
import DropDown from './modules/DropDown';
import ModalDialog from './modules/Popup';
import Icon from '@vds/icons';
import {Line} from '@vds/lines';
import styled from 'styled-components';
import {Title} from '@vds/typography';
import NBA from './modules/NBA';
import Search from './modules/Search';
import ChatIcon from "../assets/resources/images/chat_blk.png"
import ScheduleIcon from "../assets/resources/images/history-blk.png"
import MessangerIcon from "../assets/resources/images/iconmonstr-facebook-messenger-1.png"
import PhoneIcon from "../assets/resources/images/Phone.png"
import { CMS_LOCATION, MS_LOCATION, CONTACT_US_PAGE_CATEGORY, CONTACT_US_PAGE_SUBCATEGORY } from '../constants/constants';
import '../assets/css/contactus.css';
import '../assets/css/banner.css';
import { RTCICall, MetricRTCICall } from "./modules/RTCICall";
import { getOS, isNullOrUndefined, saveMetrics, makeCall, updateUserID, RemoveHeaderHiddenClass } from "./modules/CommonFunctions";
import ErrorBoundary from './modules/ErrorHandler';
import { SiteCatalyst } from '../components/modules/SiteCatalyst';
import {Chat} from'../components/modules/IncludeChat';
import { CovidAlert } from './modules/CovidAlert';
import {ContactUsHelloBanner} from './modules/ContactUsHelloBanner';
import {setNativeTitleWithNavigation, getValuesFromUserAgent, nativeBackAction,versionCompare,nativeHideTopBar,nativeUpdateFab, nativeSmartLinkToExternalBrowser,showTopTabs,checkBotAvailable,launchChatBot} from "../actions/native";
import CaretImage from "../assets/resources/images/caret.png";
import { getCookieValue } from "./modules/CommonFunctions";
const StyledLine = styled.div`padding-top:16px;padding:20px`
const StyledLineNext = styled.div `height:3px`
const styledLineLight = styled.div `height:2px`
const StyledPageTitle = styled.div`text-align:center;display:inline-block;  margin-left: 106px;font-family:Verizon NHG eTX`
const StylePageLine = styled.div`height:2px;`
const StyledMainContent = styled.div`padding-left:17px`
const MainContainer = styled.div`display:flex`
const StyledFrequent = styled.div`padding-left:20px;padding-top:10px`
const hideheader ={
    "display": 'none'
}
const QuestionleftStyle ={
    "margin-left" :"9px"
}
const FrequentSpace ={
    "margin-top" :"-20px"
}
const FrequentLine ={
    "height" :"1.1px",
    "background-color" :"black"
}
//contact us oneapp page 
class ContactUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            scheduleCall: false,
            StoredChatBot :'',
            clicked: false
        }
        this.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;
        this.isHomeApp=(/VZ_HOME_APP/i.test(navigator.userAgent))?true:false;
        this.dialogStyle = (this.isMobile) ? { "top": "50%", "position": "fixed", "transform": "translate(-40%, -45%)" } : { "top": "50%", "position": "fixed", "transform": "translate(20%, -45%)" }
        this.errorElement = "";
        this.autoCompleteRef = React.createRef();
        this.inputRef = React.createRef();
        this.dialogRef = React.createRef();
        this.conformJSON = {};
        this.phoneNumbers = [];
        this.dialogContent = "<span>We cannot process your request at this time.</span><p>For additional assistance, call 1-800-VERIZON (1-800-837-4966).</p>";
        this.conformData = "";
        this.scheduledTime = "";
        this.successHeader = "Thank you";
        this.failureHeader = "We're sorry";
        this.meridian = "";
        this.pasteActionHandler = this.onPasteValue.bind(this);       
        this.isValidUser = false;
        if(window.userinfo !== null) {this.isValidUser = true;}
        this.pegaID = (this.isValidUser && !isNullOrUndefined(window.contactUsDynamicData.Attribute) && !isNullOrUndefined(window.contactUsDynamicData.Attribute.content)) ? window.contactUsDynamicData.Attribute.content : "";
        this.topicValue = "";
        this.subTopicValue = "";
        this.timeValue = "";
        this.isaccountId = getCookieValue("adbid");
        this.metricsArgs = {
            os: getOS(),
            category: CONTACT_US_PAGE_CATEGORY,
            subCategory: CONTACT_US_PAGE_SUBCATEGORY,
            pegaSessionID: this.pegaID,
            userid: (this.isValidUser) ? window.userinfo.userId : "",
            visionID: (this.isValidUser) ? window.userinfo.visionId : "",
            accountID: (this.isValidUser) ? window.userinfo.visionAcctId : ""
        }
        this.BTN = "";
        this.IsOneApp = false;
        if(window.oneAppFlag == true && window.oneAppFlag != null){
            this.IsOneApp = "";
            this.IsOneApp = true;
        }
        this.UserName ="";
        if(window.oneAppFlag == true && window.oneAppFlag != null){
            if(window.userinfo != null)
            this.UserName = window.userinfo.details.greetingname !== null ? window.userinfo.details.greetingname : "there" ; //APP
        }      
    
        this.chkIsFiosOnly = false;
        localStorage.removeItem("IsFiosOnlyFlag");//CXTDT-250100
        localStorage.setItem('IsFiosOnlyFlag',false);
        if (window.location.href.indexOf("src=FiosOnly") > -1) {
            this.chkIsFiosOnly = true;
            localStorage.setItem('IsFiosOnlyFlag',true);
        }
        if (document.querySelector('.show_spinner') !== null) {
            document.querySelector('.show_spinner').classList.remove('show_spinner');
        }
        localStorage.removeItem("ParentPageName");
    }

    navigateBack() {
        this.setState({
            scheduleCall: false
        })
    }

    checkTime() {
        // window.location.href = window.location.href + "/callme.htm"
        this.isValidUser = true;
        let BusinessHrs = false;
        let dt = new Date();
        dt.setTime(dt.getTime() + dt.getTimezoneOffset() * 60 * 1000);
        let offset = -240; //Timezone offset for EST in minutes.
        let estDate = new Date(dt.getTime() + offset * 60 * 1000);
        if (estDate.getHours() < 24 && this.isValidUser) {
            if (estDate.getHours() < 24) {
                BusinessHrs = true;
            }           
            if (BusinessHrs) {
                this.BTN = (this.phoneNumbers.length > 0) ? this.phoneNumbers[0].toString() : "";
                this.setState({ scheduleCall: true })
                // window.location.href = window.location.href.indexOf('contactuslanding.htm') > -1 ? window.location.href.substring(0, window.location.href.indexOf('us') + 2) + "/callme.htm" : window.location.href + "/callme"
            }
            else {
                this.updateDialogContent(this.dialogContent, this.failureHeader);
            }
        } else {
            this.updateDialogContent("<p>Please sign-in to schedule a call or call 1-800-VERIZON (1-800-837-4966) for assistance.</p>", this.failureHeader);
        }
    }

    updateDialogContent(content, header) {
        this.dialogRef.current.querySelector('.modal_header .heading').innerHTML = header;
        this.dialogRef.current.querySelector('.modal_content .padding-vert-small').innerHTML = content;
        this.dialogRef.current.classList.add('active');
        this.dialogRef.current.classList.remove('hide_dialog');
        document.getElementsByClassName('page-overlay')[0].classList.add('active');
        document.getElementsByClassName('page-overlay')[0].classList.remove('hide_dialog');
        this.dialogRef.current.querySelector('.modal_x').focus();
    }

    buttonKeyActionHandlers(e) {
        if (e.keyCode === 13) {
            this.handleClickAction(e);
        }
    }
    handleClickAction(e) {
        let scLinkTrackID = e.target.getAttribute('data-sclinktrackid');
        let metrics = e.target.getAttribute('data-savemetrics');
        //   let makecall = e.target.getAttribute('data-makecall');
        MetricRTCICall(this.metricsArgs, scLinkTrackID);
        if (!isNullOrUndefined(scLinkTrackID)) {
            // window.scLinkTrackID(scLinkTrackID);
        }
        // if(!isNullOrUndefined(makecall)) {
        //     let value = makecall.split(',');
        //     makeCall(value);
        // }
        // if(!isNullOrUndefined(metrics)) {
        //     saveMetrics(metrics);
        // }
        if (e.target.innerText.toLowerCase() === "message us") {
            window.open("https://m.me/fios");
        } else if (e.target.innerText.toLowerCase() === "call me") {
            this.checkTime();
        } else {
            e.target.innerText = "Chat in progress";
            
            window.EchannelVera.init({});
            // window.initiateChat();
            //ChatusRefresh
          
        }
    }

    toggleCheckBox(e) {
        if (e.target !== undefined) {
            if (!e.target.classList.contains('checked')) {
                let id = e.target.getAttribute('for');
                e.target.parentElement.querySelector("#" + id).checked = true;
                let prevItem = document.querySelector('.checked').getAttribute('for');
                document.querySelector('#' + prevItem).checked = false;
                document.querySelector('.checked').classList.remove('checked');
                e.target.classList.add('checked');
                this.BTN = !isNullOrUndefined(e.target.innerText) ? e.target.innerText : "";
            }
            if (document.querySelector('.custom_checkbox').isChecked) {
                this.validateCheckBox(document.querySelector('.custom-phone-input'));
            }
        }
    }


    enableConfirmButton(e) {
        document.querySelector("#callmeButton").classList.remove('disabled');
    }

    updateErrorElement() {
        this.errorElement = document.querySelector('.error');
    }

    handleConfirmCall(e) {
        if (e.keyCode === 13) {
            this.scheduleCall();
        }
    }

    scheduleCall() {
        if (this.BTN === "") {
            this.validatePhoneNumber();
            return;
        }
        document.querySelector('.hide_spinner').classList.add('show_spinner');
        let localInstance = this;
        if (this.timeValue !== "" && !isNullOrUndefined(this.timeValue)) {
            //  window.scLinkTrackID("confirm- " + this.timeValue + " " + this.topicValue + ": " + this.subTopicValue);
        } else {
            //  window.scLinkTrackID("confirm- " + this.topicValue + ": " + this.subTopicValue);
        }
        fetch(MS_LOCATION + "/callme/register", {
            method: "POST",
            headers: new Headers({
                'content-type': 'application/json'
            }),
            body: JSON.stringify(localInstance.conformJSON)
        }).then(function (response) {
            return response.json();
        }).then(function (json) {
            if (document.querySelector('.show_spinner') !== null) {
                document.querySelector('.show_spinner').classList.remove('show_spinner');
            }
            if (json.VZCBResponse !== undefined && json.VZCBResponse !== null && json.VZCBResponse.Body.RegisterCallbackResponse.StatusCode === 0) {
                if (document.querySelector('.ddl3') !== null && document.querySelector('.ddl3') !== undefined) {
                    let selectedDate = document.querySelector('.ddl3 .text').innerText;
                    selectedDate = (selectedDate.indexOf('today') > -1) ? "Today, " + localInstance.scheduledTime + " " + localInstance.meridian : (selectedDate.indexOf('Tomorrow') > -1) ? "Tomorrow, " + localInstance.scheduledTime + " " + localInstance.meridian : "as soon as an agent is available";
                    let dialogContent = "<span id='regcbcontP'>Your call is scheduled for: </span><h5 class='heading' id='regcbcont'>" + selectedDate + "</h5><p id='regcbcontNP'>Please remember times are approximate and may vary according to agent availability.</p>";
                    localInstance.updateDialogContent(dialogContent, localInstance.successHeader);
                } else {
                    let dialogContent = "<span id='regcbcontP'>Your call is scheduled for: </span><h5 class='heading' id='regcbcont'>Today, as soon as an agent is available</h5><p id='regcbcontNP'>Please remember times are approximate and may vary according to agent availability.</p>";
                    localInstance.updateDialogContent(dialogContent, localInstance.successHeader);
                }

            } else {
                localInstance.updateDialogContent(localInstance.dialogContent, localInstance.failureHeader);
            }
        }).catch(function (e) {
            if (document.querySelector('.show_spinner') !== null) {
                document.querySelector('.show_spinner').classList.remove('show_spinner');
            }
            localInstance.updateDialogContent(localInstance.dialogContent, localInstance.failureHeader);
        })

    }
	//oneapp functions
    updateData(topic, supTopic, time, GID, meridian, priority) {
        this.scheduledTime = time;
        this.meridian = meridian;
        this.topicValue = topic;
        this.subTopicValue = supTopic;
        this.timeValue = time;
        this.conformJSON = {
            "VZCBRequest": {
                "Header": {
                    "ClientName": "MYFIOS",
                    "ClientIP": "68.134.166.232",
                    "TransactionID": -549845223,
                    "RequestName": "RegisterCallback"
                },
                "Body": {
                    "RegisterCallbackRequest": {
                        "GlobalSessionID": GID,
                        "Topic": topic,
                        "SubTopic": supTopic,
                        "CBType": priority,
                        "CBR": this.BTN.replace(/[^0-9]/g, ''),
                        "QueueName": "NewCustSales_Online",
                        "SelectedSlot": time,
                        "CustomerID": window.userinfo.details.vcustid,
                        "Authenticated": 1,
                        "ACCOUNT_ID": window.userinfo.visionId + window.userinfo.visionAcctId,
                        "ACCOUNT_TYPE": "VISION",
                        "BTN": {}
                    }
                }
            }
        }
    }

    validateCheckBox(input) {
        this.updateErrorElement();
        if (input.value.length < 10) {
            this.errorElement.classList.add('validated');
            this.errorElement.innerText = "Please enter a valid 10 digit phone number";
        } else {
            this.errorElement.classList.remove('validated');
        }
        if (input.value.length === 10) {
            const checkSameVal = input.value.split('').every(function (value) {
                return value === input.value[0];
            })
            if (checkSameVal) {
                this.errorElement.innerText = "All digits are same, Please check."
                this.errorElement.classList.add('validated');
            }
        }
        if (!isNullOrUndefined(document.querySelector('.checked')) && !isNullOrUndefined(document.querySelector('.checked').getAttribute('for')) &&
            !isNullOrUndefined(document.querySelector("#" + document.querySelector('.checked').getAttribute('for')))) {
            document.querySelector("#" + document.querySelector('.checked').getAttribute('for')).checked = false;
        }
        document.getElementsByClassName('custom_checkbox')[0].checked = true;
    }

    validatePhoneNumber() {
        this.validateCheckBox(this.inputRef.current);
        this.BTN = (this.errorElement.classList.contains('validated')) ? "" : document.querySelector('#custom_number').value;
    }

    validateOnKeyUp(e) {
        this.updateErrorElement();
        if (this.errorElement.classList.contains('validated') && e.target.value.length === 10) {
            this.errorElement.classList.remove('validated');
        }
    }

    validateOnKeyDown(e) {
        if (e.target.value.length === 10 && e.keyCode !== 8 && e.keyCode !== 46) {
            e.preventDefault();
        } if (e.keyCode === 9) {
            setTimeout(() => {
                document.querySelector('.ddl1').focus();
                document.querySelector('.ddl1').classList.add('keyboard_focus');
            }, 100);
        }
    }

    loadLocalImage(name) {
        let imagePath;
        if (name === "callme") {
            imagePath = "/content/dam/verizon/support/consumer/supportservices/vcm-react/media/call-icon.svg";
        } else if (name === "chatnow") {
            imagePath = "/content/dam/verizon/support/consumer/supportservices/vcm-react/media/contact-chat-icon.svg";
        } else if (name === "messageus") {
            imagePath = "/content/dam/verizon/support/consumer/supportservices/vcm-react/media/fbmessage.png";
        }
        return imagePath;
    }

    closeDialog(e) {
        if (!isNullOrUndefined(e.keyCode) && (e.keyCode !== 13 && e.keyCode !== 27)) {
            return;
        }
        this.dialogRef.current.classList.add('hide_dialog');
        document.getElementsByClassName('page-overlay')[0].classList.add('hide_dialog');
        document.getElementsByClassName('page-overlay')[0].classList.remove('active');
        this.dialogRef.current.classList.remove('active');
        this.setState({ scheduleCall: false });
    }

    componentDidMount() {
       
        let operatingSystem = getOS();
        let intent = "";
        let nbaCount = 0;
        let args = {
            subCategory: CONTACT_US_PAGE_SUBCATEGORY,
            contact_category: CONTACT_US_PAGE_CATEGORY,
            intentCategory: "Support",
            activityCategory: "Support",
            intent: "ONEAPP_CONTACT_US",
            app_n_channel: "ONEAPP_CONTACT_US",
            app_channel: "ONEAPP_CONTACT_US",
            app_contact: "ESUPPORT_CONTACTUS",
            os: operatingSystem,
            pegaSessionID: "",
            userid: (this.isValidUser) ? window.userinfo.userId : "",
            visionID: (this.isValidUser) ? window.userinfo.visionId : "",
            accountID: (this.isValidUser) ? window.userinfo.visionAcctId : ""
        };
        RTCICall(args);
        Chat();  
        if (window.oneAppFlag == true && window.oneAppFlag != null) {
          if (window.location.href.indexOf("src=FiosOnly") > -1) {
          } else {
            showTopTabs();
          }
          if (this.isHomeApp) {
            nativeBackAction("Contact Us");
          } else {
            const { channelId, version } = getValuesFromUserAgent(
              navigator.userAgent
            );
            if (
              (versionCompare(version, "11.1.0") &&
                channelId.toUpperCase() === "VZW-MFA-IOS") ||
              (versionCompare(version, "18.2.0") &&
                channelId.toUpperCase() === "VZW-MFA-ANDROID")
            ) {
              nativeBackAction("Contact Us");
            } else {
              setNativeTitleWithNavigation("Contact Us", true);
            }
          }
          nativeUpdateFab(true);
        }
        checkBotAvailable();     

        window.chatcallback = (scannedData = '{}') => {
            
           // this.checklogChatbot("chatcallbackResponse" +scannedData);
            const result =  JSON.parse(scannedData);          
            this.setState({ StoredChatBot: result })              
                 
        };   
       
       
    }    
   
   
     checklogChatbot(scannedData){
        try{
            let operatingSystem = getOS();
            let AvailbityChatBot = scannedData; 
            let availchatvalue = "chatcallback_response :" + AvailbityChatBot;
            console.log("Check chatbotAPP :"+AvailbityChatBot); 
            let args1 = {
             subCategory: CONTACT_US_PAGE_SUBCATEGORY,
             contact_category: CONTACT_US_PAGE_CATEGORY,
             intentCategory: "Support",
             activityCategory: "Support",
             intent: "ONEAPP_CONTACT_US",
             app_n_channel: "ONEAPP_CONTACT_US_VALIDCHATUS",
             app_channel: "ONEAPP_CONTACT_US_VALIDCHATUS",
             app_contact: "ESUPPORT_CONTACTUS_VALIDCHATUS",
             os: operatingSystem,
             pegaSessionID: "",
             userid: (this.isValidUser) ? window.userinfo.userId : "",
             visionID: availchatvalue,
             accountID: availchatvalue
         };
         RTCICall(args1);
         }catch(e){}
     }

    onPasteValue(e) {
        e.preventDefault();
        var newValue = this.inputRef.current.value + e.clipboardData.getData("Text");
        if (newValue.length > 10) {
            this.inputRef.current.value = newValue.substring(0, 10);
        }
    }

    getECRMData() {
        this.phoneNumbers = [];
        if (this.props.ECRMData === null || this.props.ECRMData === undefined) { this.phoneNumbers = []; return }
        if (Object.keys(this.props.ECRMData).length === 0 || (Object.keys(this.props.ECRMData).length > 0 && this.props.ECRMData.ecrmStatus !== "success")) {
            this.phoneNumbers = [];
            return
        }
        if (this.props.ECRMData !== null && this.props.ECRMData !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData !== undefined) {
            if (!isNullOrUndefined(this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.LookupStatus) && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.LookupStatus.toLowerCase() === "failed") {
                this.phoneNumbers = [];
                return;
            }
            if (this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo.BTN !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo.BTN !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo.BTN !== "") {
                this.phoneNumbers.push(this.changeNUmberIntoMaskFormat(this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo.BTN.toString()));
            }
            if (this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.AlternateTN !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.AlternateTN !== undefined) {
                this.phoneNumbers.push(this.changeNUmberIntoMaskFormat(this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.AlternateTN.toString()));
            }
            if (this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo.MTN !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo.MTN !== undefined) {
                this.phoneNumbers.push(this.changeNUmberIntoMaskFormat(this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo.MTN.toString()));
            }
        }
    }

    changeNUmberIntoMaskFormat(phoneNumber) {
        return "(" + phoneNumber.substring(0, 3) + ") " + phoneNumber.substring(3, 6) + "-" + phoneNumber.substring(6);
    }

    refreshChatUs(){
        return(document.getElementById("Chatnow").innerText ="Chat now") ;
 
     }
     LoadChatwithus(e){
        localStorage.setItem('IsContactLoaded',true);
        setNativeTitleWithNavigation("Chat with us", true);
        nativeUpdateFab(true);   
        if(this.state.StoredChatBot != null && this.state.StoredChatBot != 'undefined' && this.state.StoredChatBot !=""){    
            let strdata = JSON.stringify(this.state.StoredChatBot);       
            let strjsondata = JSON.parse(strdata);
            let chkChatbotAvl = strjsondata.onebotAvailable;  
           // this.checklogChatbot("LoadChatwithusResponsed" +this.state.StoredChatBot );    
            if(chkChatbotAvl == false)
            {
                // window.initiateChat();   
                window.EchannelVera.init({});         
            }
            else
            {           
                launchChatBot();
            }
        }else{
           // this.checklogChatbot("LoadChatwithusElsed" +this.state.StoredChatBot);
            // window.initiateChat();    
            window.EchannelVera.init({}); 
        }
     }
     LoadSchedulePage(e){
        if (!this.state.clicked) {
        localStorage.setItem('IsContactLoaded',true);
          setNativeTitleWithNavigation("Schedule callback", true);
        //CXTDT-281499 fix
        nativeUpdateFab(true);
        //window.constructScData('tab', "Schedule a call");
        let navpath ="/support/"+window.domain_url+"/contact-us/callme.htm";
        window.location.href = navpath;
       //  this.checkTime();
       this.setState({clicked: true});
    }
     }
     LoadMessanger(e){
        localStorage.setItem('IsContactLoaded',true); 
        nativeSmartLinkToExternalBrowser(
          "https://m.me/fios",
          "Connect on Messenger"
        );
        setNativeTitleWithNavigation("Connect on Messenger", true);
        nativeUpdateFab(true);
        //setNativeTitleWithNavigation('Connect on Messenger', true);
       // nativeUpdateFab(true);
       // window.location.href = "https://m.me/fios";
     }
     LoadQuestionMobile(e){
        localStorage.setItem('IsContactLoaded',true);
          setNativeTitleWithNavigation("Add Mobile service", true);
          nativeUpdateFab(true);
        let navpath ="https://www.verizon.com/promos/verizon-fios-installation-promo/";
        window.location.href = navpath;
     }
    render() {
        if (!this.state.scheduleCall) {
            document.body.classList.add('contact_us');
            let loadChatImage ;
            let careticon;

            this.careticon = CaretImage;
            loadChatImage = ChatIcon
            return (
               
            <React.Fragment> 
            <section className="main " role="region"> 
                <div className="container">
                    <ErrorBoundary>
                            <ContactUsHelloBanner HelloTitle={"Hi"+ " " +this.UserName +","} 
                            HelloDesc="Have a question about your Fios service?"></ContactUsHelloBanner>
                    </ErrorBoundary>

                    <div className="ContactusMain" tabIndex="0" onClick={this.LoadChatwithus.bind(this)} role="button" data-track="Chat with us"
                    aria-describedby="Chat with us Your quickest option">
                            <div flex="true" className="maincontentflex">
                            <img src={ChatIcon} alt=" " aria-hidden="true" className="ChatUsiconClass"></img>
                            <MainContainer >
                                <StyledMainContent>
                                    <Title size="small" ariaLabel="Chat with us Your quickest option"  bold viewport="mobile">Chat with us </Title>
                                    <div aria-hidden="true">Your quickest option </div>
                                </StyledMainContent>
                            </MainContainer>
                        </div>
                        <div className="CarretArroicon">
                            <span className="CaretArrow"> 
                                <img src={this.careticon} alt=" " aria-hidden="true" ></img> 
                            </span>
                        </div>
                    </div>

                    <div className="Helorow" > 
                        <StyledLineNext>
                        <Line type="xLight"/>
                        </StyledLineNext>
                    </div>

                    <div className="ContactusMain" tabIndex="0"  onClick={ this.state.clicked ? null : this.LoadSchedulePage.bind(this)}  role="button" 
                    data-track="Schedule a Call"
                    aria-describedby="Schedule a call Skip the hold time and receive a call in 10 to 15 mins">
                            <div flex="true" className="maincontentflex">
                                <img src={ScheduleIcon} alt=" " aria-hidden="true" className="ScheduleCalliconClass"></img>
                                <MainContainer >
                                    <StyledMainContent>
                                        <Title size="small" ariaLabel="Schedule a call Skip the hold time and receive a call in 10 to 15 mins" viewport="mobile">Schedule callback </Title>
                                        <div aria-hidden="true">Skip the hold time and receive a call </div>
                                        <div aria-hidden="true">in 10-15 mins.</div>
                                    </StyledMainContent>
                                </MainContainer>
                            </div>
                            <div className="CarretArroicon">
                                <span className="CaretArrow"> 
                                    <img src={this.careticon} alt=" " aria-hidden="true" ></img> 
                                </span>
                            </div>
                    </div>   

                    <div className="Helorow" > 
                        <StyledLineNext>
                        <Line type="xLight"/>
                        </StyledLineNext>
                    </div>

                    <div className="ContactusMain" tabIndex="0" onClick={this.LoadMessanger.bind(this)} role="button" data-track="Connect on Messenger"
                    aria-describedby="Connect on Messenger Chat with our social response team available 24/7">
                            <div flex="true" className="maincontentflex">
                            <img src={MessangerIcon} alt=" " aria-hidden="true" className="MessengericonClass"></img>
                            <MainContainer >
                                <StyledMainContent>
                                    <Title size="small" ariaLabel="Connect on Messenger Chat with our social response team available 24/7" viewport="mobile">Connect on Messenger </Title>
                                    <div aria-hidden="true">Chat with our social response team,</div>
                                    <div aria-hidden="true">available 24/7.</div>
                                </StyledMainContent>
                            </MainContainer>
                        </div>
                        <div className="CarretArroicon">
                            <span className="CaretArrow"> 
                                <img src={this.careticon} alt=" " aria-hidden="true" ></img> 
                            </span>
                        </div>
                    </div>
                   {
                    this.chkIsFiosOnly && <div className="Helorow" > 
                        <StyledLineNext>
                        <Line type="xLight"/>
                        </StyledLineNext>
                    </div>
                  }
                  {
                    this.chkIsFiosOnly && <div className="ContactusMain" tabIndex="0" onClick={this.LoadQuestionMobile.bind(this)} 
                    data-track="Add Mobile service" aria-label="Add Mobile service Get exclusive prices just for Fios customers.">
                            <div flex="true" className="maincontentflex">
                            <img src={PhoneIcon} alt=" " aria-hidden="true" className="MobileServiceiconClass"></img>
                            <MainContainer >
                                <StyledMainContent>
                                    <Title size="small" ariaHidden={true} viewport="mobile"><div style={QuestionleftStyle}>Add Mobile service</div> </Title>
                                    <div aria-hidden="true" style={QuestionleftStyle}>Get exclusive prices just for Fios customers.</div>                                    
                                </StyledMainContent>
                            </MainContainer>
                        </div>
                        <div className="CarretArroicon">
                            <span className="CaretArrow"> 
                                <img src={this.careticon} alt=" " aria-hidden="true" ></img> 
                            </span>
                        </div>
                    </div>
                }
                    <StyledLine>
                        <Line type="xLight"/>
                    </StyledLine>

            </div>

            <div>
                <StyledFrequent><Title size="large" ariaLabel="Frequent topics" viewport="mobile">Frequent topics</Title></StyledFrequent>
            </div>

            <div className="Helorow" > 
                <StyledLineNext>
                     <div style={FrequentLine}></div>
                </StyledLineNext>
            </div>
                    
            <div className="w_frequent-topics-details" style={FrequentSpace}>
                <ErrorBoundary>
                    <SolutionsList PegaSessionID={this.pegaID} Title="" Items={this.props.ContactData.collist[1].xflist[0].linkList[0].Popuplist} BannerImage=""></SolutionsList>
                </ErrorBoundary>
            </div> 
            
            <ErrorBoundary>
                <ModalDialog CloseCallBack={this.closeDialog.bind(this)} DialogRef={this.dialogRef} DialogHeader="More contact Options" DialogStyle={this.dialogStyle}></ModalDialog>
            </ErrorBoundary>          
    </section> 
    <input type="hidden" value={(this.isValidUser) ? "Auth" : "UnAuth"} id="loginType" />
    <ErrorBoundary>
        <SiteCatalyst PageDetails={this.props.ContactData.pagedetails} />
    </ErrorBoundary>           
    </React.Fragment>
    )
    }
        else {
            return (
                <React.Fragment>
                    
                    <section className="contactuspages" id="cu_main" role="region">
                        <div className="container">
                        <div className="row contactus-page" id="callMeSection">
                                <div className="columns call-schedule medium-7 myfios-first_col">
                                     <div className="w_talk-tile">
                                          <div className="w_tile-top-content" id="">
                                          <div className="w_tile-head" style={hideheader}>
                                                <p id="contactUs" className="contactus" onClick={this.navigateBack.bind(this)}>
                                                    <a className="m_button-back" tabIndex="0" data-track="Contact Us" >Contact Us</a>
                                                </p>
                                                <img alt="phone" className="m_phone-icon" src="/content/dam/verizon/support/consumer/supportservices/vcm-react/media/contact-phone-icon.svg" />
                                                <h2>Schedule a call</h2>
                                            </div>
                                            <div className="w_head-content">
                                                <p>Enter a phone number and choose a topic below.</p>
                                                <div className="m_input-field">
                                                    <label>Phone Number</label>
                                                    <div className="phone-numbers">
                                                        {
                                                            this.phoneNumbers.map((item, index) => {
                                                                return <React.Fragment key={item}>
                                                                    <input data-cs-mask type="radio" defaultChecked={(index === 0) ? true : false} className={"m_phone-" + index} id={"radio" + index} tabIndex="0" value={item} />
                                                                    <label htmlFor={"radio" + index} role="radio" aria-checked={(index === 0) ? true : false} aria-required={false} className={(index === 0) ? " checked checkbox" : "checkbox"} onClick={this.toggleCheckBox.bind(this)}>
                                                                        {item}
                                                                    </label>
                                                                    <br />
                                                                </React.Fragment>
                                                            })
                                                        }

                                                        <input data-cs-mask type="radio" defaultChecked={(this.phoneNumbers.length > 0) ? false : true} className={"custom_checkbox m_phone-" + this.phoneNumbers.length} id={"radio" + this.phoneNumbers.length} name="" tabIndex="0" />
                                                        <label htmlFor={"radio" + this.phoneNumbers.length} role="radio" className={(this.phoneNumbers.length > 0 ? "checkbox" : "checked checkbox")} aria-checked={(this.phoneNumbers.length > 0) ? false : true} aria-required={false} onClick={this.toggleCheckBox.bind(this)}></label>
                                                        <input data-cs-mask type="number" ref={this.inputRef} className={"custom-phone-input m_phone" + this.phoneNumbers.length} id="custom_number" placeholder="Enter a phone number" tabIndex="0" onKeyDown={this.validateOnKeyDown.bind(this)} onKeyUp={this.validateOnKeyUp.bind(this)} onBlur={this.validatePhoneNumber.bind(this)} />
                                                    </div>
                                                    <span className="error"></span>
                                                </div>
                                                <ErrorBoundary>
                                                    <DropDown GID={this.props.globalSessionID} DDlData={this.props.ContactData.callMe[0]} ValidateCheckBox={this.toggleCheckBox.bind(this)} EnableConfirmButton={this.enableConfirmButton} ConformCall={this.updateData.bind(this)} />
                                                </ErrorBoundary>
                                            </div>
                                            <div className="submit_btn">
                                                <a className="submit_button button p-50 disabled" id="callmeButton" tabIndex="0" role="button" onClick={this.scheduleCall.bind(this)} onKeyDown={this.handleConfirmCall.bind(this)} data-track="Confirm">Confirm</a>
                                            </div>
                                          </div>
                                   </div>
                               </div>
                               <div id="spinner" className="hide_spinner">
                                    <div data-page-loader className="text-center page-loader text-white active">
                                        <div className="loader small text-center"></div> </div>
                                    <center><img alt="spinner" src="/content/dam/verizon/support/consumer/supportservices/vcm-react/media/spinner.gif" /></center>
                                </div>
                        </div>
                        </div>
                        <ErrorBoundary>
                            <ModalDialog CloseCallBack={this.closeDialog.bind(this)} DialogRef={this.dialogRef} DialogHeader="More contact Options" DialogStyle={this.dialogStyle}></ModalDialog>
                        </ErrorBoundary>
                    </section>
                    <input type="hidden" value="Auth" id="loginType" />
                    <ErrorBoundary>
                        <SiteCatalyst PageDetails={this.props.ContactData.pagedetails} />
                    </ErrorBoundary>
                </React.Fragment>
            )
        }
    }
}
export default ContactUs



// WEBPACK FOOTER //
// ./src/components/ContactUsPageOneApp.js